import { useQuery } from '@tanstack/react-query';
import * as Api from '../api';

export interface PublicTestCardItem {
  id: string;
  title: string;
  description?: string;
  category?: string;
  accessType: 'FREE' | 'PAID' | 'PLAN';
  priceSom: number;
  durationMinutes: number;
  questionsCount: number;
  sectionsCount: number;
  tags?: string[];
  difficultyLevel?: string;
  coverImageUrl?: string;
  createdAt?: string;
}

interface IProps {
  params?: {
    category?: string;
    subject?: string;
    accessType?: string;
    difficulty?: string;
    search?: string;
    page?: number;
    perPage?: number;
  };
  enabled?: boolean;
}

export const usePublicTests = ({ params, enabled = true }: IProps = {}) => {
  return useQuery({
    queryKey: ['public-tests', params ?? {}],
    enabled,
    queryFn: async () => {
      const res = await Api.PublicTests(params);
      return {
        items: res.data.data as PublicTestCardItem[],
        meta: res.data.meta,
      };
    },
  });
};

export default usePublicTests;
